import Axios from 'axios';

const shorten = async (url) => await Axios.get(`https://is.gd/create.php?format=json&url=${url}`);

export default shorten;
